import { Component } from "react";

export const isNested = Symbol("nested");

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const noop = () =>
  Promise.resolve({
    default: class Noop extends Component {
      render() {
        return "Noop";
      }
    },
  });

noop.isNested = isNested;
